<template>
    <rkm-area
        title="Atendimento"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-checkbox v-model="data.model.exibeMensagemAtendimentoRetroativoNaoFinalizado">
                    Exibe mensagem de atendimento retroativo não finalizado
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox v-model="data.model.exibeBoxExameLaboratorialSolicitado">
                    Exibe exames laboratoriais predefinidos
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox v-model="data.model.receitaNaoPadronizadaJustificativaObrigatoria">
                    Obriga justificativa para receita não padronizada
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox v-model="data.model.visualizarRemume">
                    Visualizar REMUME
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox v-model="data.model.visualizarEstoque">
                    Visualizar estoque
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox v-model="data.model.cadastroPrescricoes">
                    Cadastro de prescrições
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox v-model="data.model.permiteExameLaboratorialRepetido">
                    Permitir a solicitação de exame laboratorial já solicitado e em andamento.
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox v-model="data.model.permiteExameImagemRepetido">
                    Permitir a solicitação de exame de imagem já solicitado e em andamento.
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox v-model="data.model.permiteEncaminharRepetido">
                    Permitir a solicitação de um encaminhamento já solicitado e em andamento.
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox v-model="data.model.permitePrescricaoRepetida">
                    Permitir a solicitação de uma prescrição de medicamento já solicitada e em andamento.
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-area
            no-margin-top
            title="Impressões"
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        label="Modelo de impressão da SADT"
                        v-model="data.model.modeloImpressaoSadt"
                    >
                        <rkm-form-select-option value="padrao">Padrão</rkm-form-select-option>
                        <rkm-form-select-option value="especifico">Específico</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Modelo de impressão da APAC"
                        v-model="data.model.modeloImpressaoApac"
                    >
                        <rkm-form-select-option value="padrao">Padrão</rkm-form-select-option>
                        <rkm-form-select-option value="especifico">Específico</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-area>
</template>

<script>
export default {
    props: {
        data: {required: true, type: Object},
    },
}
</script>